import { render, staticRenderFns } from "./Bans.vue?vue&type=template&id=d1fc04c2"
import script from "./Bans.vue?vue&type=script&lang=js"
export * from "./Bans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports